import { useIntl } from 'react-intl';
import { forwardRef } from '@chakra-ui/react';

import { Table } from '../../Table';
import { type RowProps } from '../../Table/parts';
import { useFees } from '../context';

export type CardReplacementProps = RowProps;

export const CardReplacement = forwardRef<CardReplacementProps, 'div'>(
  (props, ref) => {
    const intl = useIntl();
    const { fees, toFixed, toVariable } = useFees();

    const locales = {
      label: intl.formatMessage({
        id: 'subscription.fees_modal.card_replacement.label',
      }),
      value: intl.formatMessage(
        {
          id: 'subscription.fees_modal.card_replacement.value',
        },
        {
          additionalPhysicalPaymentCard: toFixed(
            fees.additionalPhysicalPaymentCard,
          ),
          fixed: toFixed(fees.additionalPhysicalPaymentCardMonth),
          variable: toVariable(fees.additionalPhysicalPaymentCardMonth),
        },
      ),
    };

    return (
      <Table.Row {...props} ref={ref}>
        <Table.CellText>{locales.label}</Table.CellText>
        <Table.CellAmount>{locales.value}</Table.CellAmount>
      </Table.Row>
    );
  },
);
